module.exports = __webpack_public_path__ + "assets/05f413d8ed3f4d1aa6aefe20e2608350.png";